module.exports = __webpack_public_path__ + "static/media/Sign_out.a072d195.svg";